export class ErrorCodes {
  public static FIELD_VALIDATION_ERROR : number = -101
  public static USER_ALREADY_REGISTERED : number = -800
  public static PLAN_IDENTIFIER_NOT_FOUND : number = -701
}